import { Modal } from "@/components/molecules/Modals/ModalController";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { PopupMessage } from "../../components/atoms/PopupMessage/PopupMessage.type";
import { IRootState } from "../store";

type MessageState = {
  message: PopupMessage;
  modal: Modal;
  alerts: Alert[];
};

export type Alert = {
  type: "success" | "error" | "warning" | "info";
  title?: string;
  description: string;
  id: string;
};

const initialState: MessageState = {
  message: null,
  modal: null,
  alerts: [],
};

const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage(state, action) {
      state.message = action.payload;
    },
    clearMessage(state) {
      state.message = null;
    },
    showModal(state, action: PayloadAction<Modal | null>) {
      if (!state.modal) {
        state.modal = action.payload;
      } else {
        state.modal = null;
      }
    },
    addAlert(state, action: PayloadAction<Omit<Alert, "id">>) {
      const alert = {
        ...action.payload,
        id: action.payload.title + action.payload.description + Date.now(),
      };
      state.alerts = [...state.alerts, alert];
    },
    removeAlert(state, action: PayloadAction<string>) {
      state.alerts = state.alerts.filter(
        (alert) => alert.id !== action.payload,
      );
    },
  },
});

export const getMessageSelector = (state: IRootState) => state.messageReducer;
export const { setMessage, clearMessage, showModal, addAlert, removeAlert } =
  messageSlice.actions;
export default messageSlice.reducer;
